import { render, staticRenderFns } from "./EmailToClient.vue?vue&type=template&id=3ba8b966&"
import script from "./EmailToClient.vue?vue&type=script&lang=js&"
export * from "./EmailToClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports